import React from "react";
import { Modal, Button } from "react-bootstrap";

const ReportCommentModal = ({ show, onClose, comment }) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Report Comment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{comment}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ReportCommentModal;
